// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.c-sidebar-nav-dropdown.c-show > .c-sidebar-nav-dropdown-items {\r\n  max-height: 30000px;\n}\r\n", ""]);
// Exports
module.exports = exports;
